import { Observable } from 'rxjs';

export function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = error => reject(error);
  });
}

export function base64ToBlob(dataUrl: string): Blob {
  const arr = dataUrl.split(',');
  const mimeMatch = arr[0].match(/:(.*?);/);
  if (!mimeMatch) throw new Error('Invalid data URL');

  const mime = mimeMatch[1];
  const bstr = atob(arr[1]);
  let number = bstr.length;
  const u8arr = new Uint8Array(number);

  while (number--) {
    u8arr[number] = bstr.charCodeAt(number);
  }

  return new Blob([u8arr], { type: mime });
}

export function blobToBase64(blob: Blob): Observable<string> {
    return new Observable(observer => {
        const reader = new FileReader();
        reader.onloadend = () => {
            observer.next(reader.result as string);
            observer.complete();
        };
        reader.onerror = error => observer.error(error);
        reader.readAsDataURL(blob);
    });
}
